import React, { useState } from 'react';

import Popup from '@atlaskit/popup';

import { Text } from '@qality/common-components/src/atoms/Text';
import { ExecutionStatusSummary as ExecutionStatusSummaryModel } from '@qality/common-model';
import { ExecutionStatusUtils } from '@qality/common-utils';

import { ExecutionStatusSummaryMultiBarChart } from '../bar-chart/ExecutionStatusSummaryMultiBarChart';
import { ExecutionStatusSummaryStackedBarChart } from '../bar-chart/ExecutionStatusSummaryStackedBarChart';
import {
  ContentWrapperStyled,
  TriggerWrapperStyled,
} from './ExecutionStatusSummary.styled';

type Props = {
  statusSummary: ExecutionStatusSummaryModel;
  fallbackMessage?: string;
};

export function ExecutionStatusSummary({
  statusSummary,
  fallbackMessage = 'No executions',
}: Props): JSX.Element {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  if (ExecutionStatusUtils.isStatusSummaryEmpty(statusSummary)) {
    return <Text noData>{fallbackMessage}</Text>;
  }

  return (
    <Popup
      isOpen={isPopupOpen}
      autoFocus={false}
      placement='bottom'
      content={() => {
        return (
          <ContentWrapperStyled>
            <ExecutionStatusSummaryMultiBarChart
              statusSummary={statusSummary}
              title='Status'
            />
          </ContentWrapperStyled>
        );
      }}
      trigger={({ ref, ...triggerProps }) => {
        return (
          <TriggerWrapperStyled
            {...triggerProps}
            innerRef={ref}
            onMouseEnter={() => setIsPopupOpen(true)}
            onMouseLeave={() => setIsPopupOpen(false)}
          >
            <ExecutionStatusSummaryStackedBarChart
              statusSummary={statusSummary}
            />
          </TriggerWrapperStyled>
        );
      }}
    />
  );
}
